<mat-dialog-content>
    <pixl-editor
        [htmlString]="data.explanationContentHtml"
        [editorHeight]="'auto'"
        [bearerToken]="data.authToken"
        [assetUrl]="data.assetUrl"
        [mediaUrl]="data.mediaUrl"
        [(editedHtmlString)]="data.explanationContentHtml"
    >
    </pixl-editor>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        (click)="onCancel()"
    >{{ "abort" | transloco }}</button>
    <button
        mat-raised-button
        (click)="onSave()"
    >{{ "apply" | transloco }}</button>
</mat-dialog-actions>